const initialState = {
     users: {
        isSignedIn: false,
        role: "",
        uid: "",
        username: ""
     }
};

export default initialState